import React, { Component } from "react"
import VideoPlayer from "./VideoPlayer"
import "./App.css"

class App extends Component {
  state = {
    muted: true
  }

  render() {
    return (
      <div className="App">
        <VideoPlayer />
        <div
          className="happy-birthday"
          onClick={() => {
            console.log("Clicked!")
            var video = document.getElementById("myVideo")
            if (video.muted) {
              video.muted = false
              video.volume = 1.0
              this.setState({ muted: false })
            } else {
              video.muted = true
              this.setState({ muted: true })
            }
          }}
        >
          HAPPY BIRTHDAY<br /> PHELAN
        </div>
        <div className="mute-instructions mute-top">
          Click to {this.state.muted ? "unmute" : "mute"}
        </div>
        <div className="mute-instructions">
          Click to {this.state.muted ? "unmute" : "mute"}
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js